(function () {
  var SELECTOR = '[side-cart-shipping-cost]';
  var pending = null;
  var refreshTimer = null;
  var updating = false;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }

    var amount = (Number(cents) / 100).toFixed(2);
    if (!format) return amount;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function parseThreshold(raw) {
    if (raw == null || raw === '') return null;

    if (typeof raw === 'string') {
      try {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.amount != null) return parseFloat(parsed.amount);
      } catch (e) {}
      var asNumber = parseFloat(raw);
      return isNaN(asNumber) ? null : asNumber;
    }

    if (typeof raw === 'object' && raw.amount != null) return parseFloat(raw.amount);
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  function isDomestic(el) {
    var country = (el.dataset.country || '').toUpperCase();
    var domestic = (el.dataset.domesticCountry || 'GR').toUpperCase();
    return country === domestic;
  }

  function resolveZip(el) {
    return el.dataset.zip || el.dataset.defaultZip || '10557';
  }

  function buildRatesUrl(el, countryValue) {
    if (!countryValue) return null;

    var params = new URLSearchParams();
    params.set('shipping_address[country]', countryValue);

    if (el.dataset.province) {
      params.set('shipping_address[province]', el.dataset.province);
    }

    params.set('shipping_address[zip]', resolveZip(el));

    var root = el.dataset.cartUrl || '/cart';
    root = root.replace(/\/$/, '');
    return root + '/shipping_rates.json?' + params.toString();
  }

  function setLabel(el, text) {
    if (el.textContent === text) {
      el.dataset.shippingResolved = '1';
      return;
    }
    updating = true;
    el.textContent = text;
    el.dataset.shippingResolved = '1';
    setTimeout(function () {
      updating = false;
    }, 0);
  }

  function applyCheapestRate(el, rates) {
    if (!rates || !rates.length) return false;

    var cheapest = rates.reduce(function (min, rate) {
      var price = parseFloat(rate.price);
      if (isNaN(price)) return min;
      if (min == null || price < min) return price;
      return min;
    }, null);

    if (cheapest == null) return false;

    if (cheapest <= 0) {
      setLabel(el, el.dataset.labelFree || 'Free');
      return true;
    }

    setLabel(el, formatMoney(Math.round(cheapest * 100), el.dataset.moneyFormat));
    return true;
  }

  function fetchRates(url, signal) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal
    }).then(function (res) {
      if (!res.ok) throw new Error('shipping rates failed');
      return res.json();
    });
  }

  function updateShippingCost(el) {
    if (!el || el.dataset.shippingResolved === '1') return;

    if (el.dataset.requiresShipping === 'false') {
      setLabel(el, el.dataset.labelFree || 'Free');
      return;
    }

    var threshold = parseThreshold(el.dataset.freeThreshold);
    var subtotal = parseFloat(el.dataset.subtotal);
    if (!isNaN(subtotal)) subtotal = subtotal / 100;

    if (threshold != null && !isNaN(subtotal) && subtotal >= threshold) {
      setLabel(el, el.dataset.labelFree || 'Free');
      return;
    }

    // Non-Greece / Global-e countries
    if (!isDomestic(el)) {
      setLabel(el, el.dataset.labelCheckout || 'Calculated at checkout');
      return;
    }

    // Greece: pull live rate from Shopify Shipping
    var primaryUrl = buildRatesUrl(el, 'GR');
    var fallbackUrl = buildRatesUrl(el, 'Greece');

    if (pending) pending.abort();
    pending = new AbortController();

    fetchRates(primaryUrl, pending.signal)
      .then(function (data) {
        if (applyCheapestRate(el, data && data.shipping_rates)) return;
        return fetchRates(fallbackUrl, pending.signal).then(function (fallbackData) {
          if (!applyCheapestRate(el, fallbackData && fallbackData.shipping_rates)) {
            setLabel(el, el.dataset.labelCheckout || 'Calculated at checkout');
          }
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        return fetchRates(fallbackUrl, pending.signal)
          .then(function (fallbackData) {
            if (!applyCheapestRate(el, fallbackData && fallbackData.shipping_rates)) {
              setLabel(el, el.dataset.labelCheckout || 'Calculated at checkout');
            }
          })
          .catch(function () {
            setLabel(el, el.dataset.labelCheckout || 'Calculated at checkout');
          });
      });
  }

  function refreshAll() {
    document.querySelectorAll(SELECTOR).forEach(updateShippingCost);
  }

  function scheduleRefresh() {
    if (updating) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAll, 150);
  }

  function hasNewShippingNode(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      if (!nodes || !nodes.length) continue;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SELECTOR)) return true;
        if (node.querySelector && node.querySelector(SELECTOR)) return true;
      }
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('side_cart_opened', function () {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      delete el.dataset.shippingResolved;
    });
    scheduleRefresh();
  });
  window.addEventListener('cart:updated', function () {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      delete el.dataset.shippingResolved;
    });
    scheduleRefresh();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var host = document.querySelector('[side-cart-inner]');
    if (!host) return;

    var observer = new MutationObserver(function (mutations) {
      if (updating) return;
      if (!hasNewShippingNode(mutations)) return;
      scheduleRefresh();
    });

    observer.observe(host, { childList: true, subtree: true });
    refreshAll();
  });
})();
